<template>
  <router-view></router-view>
<!--  <div class="trader-report">
    <div class="nav-bar">
      <div class="nav-item"
           v-for="(item,index) in computedList"
           :key="index"
           :class="{
           on: item.routerName == $route.name
         }"
           @click="navHandle(item)"
      >{{item.label}}</div>
    </div>
    <div class="report-home-content page-box">

    </div>
  </div>-->
</template>

<script>
import { getIsSuperIsAgentOfcustomer } from '@/utils/common';
import { mapGetters } from 'vuex';
export default {
  name: "index",
  data() {
    let _this = this;
    return {
      pswList: [
        {label: _this.$t('Direct_customer_list'), routerName: 'report_custom'},
        {label: _this.$t('User.reportSubibList'), routerName: 'report_subIb'},
        {label: _this.$t('User.accountList'), routerName: 'accountList'},
      ]
    }
  },
  computed: {
    ...mapGetters(['userInfo']),
    computedList() {
      let copyArr = JSON.parse((JSON.stringify(this.pswList)));
      if(!this.isHasSubIbMenu){
        copyArr.splice(1,1);
      }
      if(!getIsSuperIsAgentOfcustomer(this.userInfo)){
        copyArr = copyArr.filter((item) => {
          return item.routerName !== 'report_custom';
        });
      }

      return copyArr;
    },
    isHasSubIbMenu(){
      return this.userInfo.custType !== 3 && this.userInfo.hierarchy > 1;
    }
  },
  /*mounted(){
    let reouterview = document.getElementById('routerview');
    reouterview.classList.add('no-padding-import');
  },
  beforeDestroy(){
    let reouterview = document.getElementById('routerview');
    if(reouterview){
      reouterview.classList.remove('no-padding-import');
    }
  },*/
  methods: {
    navHandle(item) {
      this.$router.push({name: item.routerName});
    }
  },
}
</script>

<style lang="scss" scoped>
@import "../../../assets/scss/variable";
.trader-report {
  .nav-bar {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding-left: 20px;
    .nav-item {
      margin-left: 20px;
      font-size: 14px;
      color: #5E5873;
      height: 100%;
      line-height: 54px;
      cursor: pointer;
      &.on {
        color: $themeColor;
        border-bottom: 2px solid $themeColor;
      }
    }
  }
  .report-home-content {
    padding: 24px;
  }
}
</style>
